import { RouteParam } from ".";
import AccessGuidePage from "../ui/pages/access_guide/AccessGuidePage";
import { ACTION, MODULE } from "../utils/enums";
import { urls } from "../utils/urls";

export const access_guide_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.access_guide,
    component: AccessGuidePage,
    main_module: MODULE.access_guide,
    action: ACTION.READ,
  },
];
